import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { RouterModule } from '@angular/router';

import { NgSelectModule } from '@ng-select/ng-select';

import { PackageEditComponent, PackageListComponent, PackageViewComponent } from './components';
import { MutualModule } from '@shared/mutual/mutual.module';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';

@NgModule({
  declarations: [PackageListComponent, PackageViewComponent, PackageEditComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NgxPaginationModule,
    PipesSharedModule,
    RouterModule,

    NgSelectModule,
    FormWrapperModule,
    MutualModule,
  ],
  exports: [PackageListComponent, PackageViewComponent, PackageEditComponent],
})
export class LclPackagesModule {}
